$( document ).ready( () => {
	const heroSlider = new Swiper( '.js-primary-hero-slider', {
		speed:        400,
		spaceBetween: 100,
		autoHeight:   true,
		loop:         true,
		pagination:   {
			el:   '.swiper-pagination',
			type: 'bullets',
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		breakpoints: {
			991: {
				// navigation: false,
			},
		},
	} );
} );
